export default __webpack_public_path__ + "static/media/_DSC5129@3x.1905f81b.png";